import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import { FormControlLabel, Tooltip, IconButton } from "@material-ui/core";
import { AntSwitch } from "../../helpers/antSwitch";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { SubPolicyTableContainer } from "./SubPolicyTable.styled";
import { theme as themeConfig } from "../../themes/themes";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[2500],
    margin: "9 0",
    color: "white",
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const SubPolicyTable = ({
  data,
  changeState,
  setOpenDeleteModal,
  handleEdit,
}) => {
  const [selectedRow, setSelectedRow] = useState();

  useEffect(() => {
    setSelectedRow();
  }, []);

  return (
    <SubPolicyTableContainer>
      {/* <h5>Sub Policy</h5> */}
      {!data && <div className="empty-msg">No records found</div>}
      {data && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell align="center">Sub Policy</TableCell>
                <TableCell align="center">LOB</TableCell>
                <TableCell align="center">Created By</TableCell>
                <TableCell align="center">Created Date</TableCell>
                <TableCell align="center">Disable</TableCell>
                <TableCell align="center"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row) => (
                <TableRow
                  key={row.idSubPolicy}
                  className={
                    row.idSubPolicy === selectedRow ? "selected-row" : ""
                  }
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.idSubPolicy}</TableCell>
                  <TableCell align="center">{row.subPolicyName}</TableCell>
                  <TableCell align="center">
                    <HtmlTooltip
                      arrow
                      placement="right"
                      title={
                        <>
                          <ul
                            style={{
                              padding: "1em 0em 1em 1.5em",
                              margin: "0",
                              listStyleType: "circle",
                              lineHeight: "1.3",
                            }}
                          >
                            {row?.lobs?.map((l, i) => (
                              <li key={i} style={{ fontSize: "11px" }}>
                                {l.name}
                              </li>
                            ))}
                          </ul>
                        </>
                      }
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: themeConfig.primary.purple,
                            borderRadius: "99px",
                            width: "22px",
                            height: "22px",
                            justifyContent: "center",
                            display: "flex",
                            alignItems: "center",
                            color: "white",
                          }}
                        >
                          {row?.lobs?.length}
                        </div>
                      </div>
                    </HtmlTooltip>
                  </TableCell>
                  <TableCell align="center">
                    {row.createUserInfo.fullName}
                  </TableCell>
                  <TableCell align="center">
                    {moment(row.createDate).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell align="center">
                    <FormControlLabel
                      control={
                        <AntSwitch
                          size="small"
                          checked={
                            row?.recordStatus === "Active" ? true : false
                          }
                          onChange={() => {
                            changeState(row);
                            row["recordStatus"] =
                              row.recordStatus === "Active"
                                ? "Inactive"
                                : "Active";
                          }}
                        />
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        zIndex: 0,
                      }}
                    >
                      <Tooltip title="Edit">
                        <IconButton
                          onClick={() => {
                            setSelectedRow(row.idSubPolicy);
                            handleEdit(row);
                          }}
                        >
                          <EditTwoTone style={{ color: themeConfig.text.primary }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          disabled={row.recordStatus === "Active"}
                          onClick={() => setOpenDeleteModal(row)}
                        >
                          <DeleteTwoTone
                            style={{
                              color: themeConfig.text.primary,
                              opacity: row.recordStatus === "Active" ? 0.5 : 1,
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </SubPolicyTableContainer>
  );
};

export default SubPolicyTable;
